import styled from 'styled-components';

export const MobilePadding = styled.div`
  @media screen and (max-width: 768px) {
    min-height: ${({ theme }) => theme.spacing(10)}px;
    width: 100%;
    display: block;
  }
`;
